// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"4f5189fe","977":"8c78e99f"}[chunkId] + ".chunk.js";
};